import { DAPI_HOST } from '../../config';

export const getMarketplaceInsurersUrl = () =>
  `${DAPI_HOST}/v1/marketplace-insurers?` +
  `&filters=marketplace_insurers.market:DFW;marketplace_insurers.specialty_field:dental;marketplace_insurers.is_popular:true`;
